const DEFAULT_SIDEBAR_FILTERS = {
  crops: [],
  cropType: {
    value: "all",
  },
  ecoSchemes: [],
  labels: [],
  municipalities: [],
  prefectures: [],
  regions: [],
  searchTerm: "",
  status: [],
  varieties: [],
};

export class FiltersDto {
  static fromApi(data) {
    return {
      id: data.id,
      name: data.name,
      description: data.description,
      type: data.filterType,
      group: {
        ...data.filterData,
        sidebar: { ...DEFAULT_SIDEBAR_FILTERS, ...data.filterData.sidebar },
      },
    };
  }
  static fromApiPaginated(data) {
    const groups = data.results;
    return groups.map(this.fromApi);
  }
  static toApi(data) {
    return {
      id: data.id,
      name: data.name,
      description: data.description,
      filterType: data.type,
      filterData: data.group,
    };
  }
}
